import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import { BreakPointDesktop } from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    width: "100%",
    display: "flex",
    position: "relative",
    boxSizing: "border-box",
    flexDirection: "column",
    [BreakPointDesktop]: {
      paddingBottom: theme.spacing.space16,
    },
  },
  pwaBanner: {
    marginBottom: theme.spacing.space12,
  },
}));
